/**
 * Dayboard column access for one person — multi-role aware.
 *
 * A person who works on vehicles (Technician or Detail Specialist work role) has their own column
 * and, on phone/tablet, lands on it. Only a worker WITHOUT dispatch authority is limited to that
 * column (other columns read-only, no kebab / timer controls on cards that are not theirs).
 * An Owner / Manager / Service Advisor / Dispatcher who also works on vehicles keeps every manager
 * control on every column: gating on "is a technician" alone hid reassignment and timer controls
 * from them once roles became a projection (multi-role audit 2026-10-10, defect 1).
 */
export interface DayboardPermissionFlags {
  isTechnician: boolean;
  isDetailSpecialist: boolean;
  canAssignTickets: boolean;
}

export interface DayboardColumnAccess {
  /** Has an own column (resolve it and land on it on phone/tablet). */
  isFloorWorker: boolean;
  /** Limited to the own column: other columns read-only, card kebab and timer controls hidden. */
  restrictToOwnColumn: boolean;
}

export function dayboardColumnAccess(p: DayboardPermissionFlags): DayboardColumnAccess {
  const isFloorWorker = p.isTechnician || p.isDetailSpecialist;
  return { isFloorWorker, restrictToOwnColumn: isFloorWorker && !p.canAssignTickets };
}
